var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.0012 37.8334C34.2818 37.8334 31.2559 34.8075 31.2559 31.0881C31.2559 27.3687 34.2818 24.3428 38.0012 24.3428C41.7206 24.3428 44.7466 27.3687 44.7466 31.0881C44.7466 34.8075 41.7205 37.8334 38.0012 37.8334ZM38.0012 27.4197C35.9784 27.4197 34.3327 29.0654 34.3327 31.0882C34.3327 33.1111 35.9784 34.7567 38.0012 34.7567C40.024 34.7567 41.6698 33.1111 41.6698 31.0882C41.6698 29.0654 40.0239 27.4197 38.0012 27.4197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.4196 47.9986H31.5829C29.5936 47.9986 27.9751 46.3925 27.9751 44.4183V41.053C27.9751 39.3751 28.4009 37.7144 29.2066 36.2504L31.9022 37.734C31.3459 38.7446 31.0519 39.8924 31.0519 41.053V44.4183C31.0519 44.6865 31.3 44.9218 31.5829 44.9218H44.4195C44.6971 44.9218 44.923 44.696 44.923 44.4183V41.053C44.923 39.7425 44.5543 38.4674 43.8569 37.3654L46.4568 35.72C47.4663 37.3149 47.9998 39.1591 47.9998 41.053V44.4183C47.9999 46.3925 46.3938 47.9986 44.4196 47.9986Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0261 37.8334C6.30674 37.8334 3.28076 34.8075 3.28076 31.0881C3.28076 27.3687 6.30674 24.3428 10.0261 24.3428C13.7455 24.3428 16.7715 27.3687 16.7715 31.0881C16.7715 34.8075 13.7454 37.8334 10.0261 37.8334ZM10.0261 27.4197C8.00331 27.4197 6.35761 29.0654 6.35761 31.0882C6.35761 33.1111 8.00331 34.7567 10.0261 34.7567C12.049 34.7567 13.6947 33.1111 13.6947 31.0882C13.6947 29.0654 12.0489 27.4197 10.0261 27.4197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.4444 47.9986H3.60781C1.61842 47.9986 0 46.3925 0 44.4183V41.053C0 39.3751 0.425836 37.7144 1.23146 36.2504L3.92708 37.734C3.37079 38.7446 3.07685 39.8924 3.07685 41.053V44.4183C3.07685 44.6865 3.32494 44.9218 3.60781 44.9218H16.4444C16.722 44.9218 16.9479 44.696 16.9479 44.4183V41.053C16.9479 39.7425 16.5792 38.4674 15.8818 37.3654L18.4817 35.72C19.4912 37.3149 20.0247 39.1591 20.0247 41.053V44.4183C20.0247 46.3925 18.4186 47.9986 16.4444 47.9986Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.3654 18.0801L32.779 14.6136C32.6958 14.5506 32.5846 14.5115 32.4887 14.5115H21.9006C19.958 14.5115 18.3774 12.9376 18.3774 11.0031V3.52719C18.3774 1.58232 19.9579 0 21.9006 0H36.2722C38.2348 0 39.8315 1.58232 39.8315 3.52719V16.8528C39.8315 18.632 37.9873 18.7688 37.3654 18.0801ZM21.9006 3.07685C21.6504 3.07685 21.4543 3.27469 21.4543 3.52719V11.0032C21.4543 11.2493 21.6462 11.4348 21.9006 11.4348H32.4887C33.2544 11.4348 34.0164 11.692 34.6344 12.1592L36.7546 13.7617V3.52719C36.7546 3.2873 36.5292 3.07685 36.2722 3.07685H21.9006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.16797 21.7231V8.44998C8.16797 6.4928 9.76106 4.90063 11.7194 4.90063H15.8134V7.97748H11.7194C11.471 7.97748 11.2448 8.20271 11.2448 8.44998V18.6359L13.3484 17.0495C13.9572 16.5893 14.7175 16.3351 15.4879 16.3351H26.0342V19.412H15.4879C15.3876 19.412 15.2783 19.4476 15.2025 19.5049L10.6327 22.9513C10.3606 23.1565 8.37617 23.6575 8.16797 21.7231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.6123 5.81958H33.5967V8.89643H24.6123V5.81958Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingIcon);
export default __webpack_public_path__ + "static/media/consultingIcon.59e9733213e0d82bb8dfc8090b18aa3c.svg";
export { ForwardRef as ReactComponent };